
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { WindowType } from '../../../../util';
import { Board, Card, Ticket } from '../../../backend/backendapi';
import { KanbanState } from '../../kanban.model';
import { getSharedInfoBoard, getSharedInfoCard } from '../../kanban.util';
import Attachments from './Attachments';
import CardInfo from './CardInfo';
import Comments from './Comments';
import Description from './Description';
import Labels from './Labels';
import Tasks from './Tasks';

declare var window: WindowType;

@Component({
  name: 'Details',
  components: {
    Attachments,
    CardInfo,
    Comments,
    Description,
    Labels,
    Tasks,
  },
})
export default class Details extends Vue {
  @Prop()
  modalId: string | undefined;
  @Prop({ required: true })
  state!: KanbanState;
  @Prop({ required: true })
  board!: Board;
  @Prop({ required: true })
  flow!: Ticket;
  @Prop({ required: true })
  card!: Card;
  @Prop({ default: false })
  readonly!: boolean;
  @Prop({ default: false })
  lockeddown!: boolean;

  get userEmails(): string[] {
    let sharedinfoboard = getSharedInfoBoard(this.state, this.board);
    let sharedinfocard = getSharedInfoCard(this.state, this.card);
    let ids = new Set([...sharedinfoboard.userIds]);
    ids.add(this.board.userId!);
    if (window.application.kanban.user) {
      ids.delete(window.application.kanban.user.id!);
    }
    let l = Array.from(new Set(this.state.users.filter(e => ids.has(e.id!)).map(e => e.email!)));

    l.sort();
    l = ['all'].concat(l);
    return l;
  }
}
